/*
 * @Author: shfang
 * @Date: 2022-06-24 15:08:36
 * @LastEditors: shfang
 * @LastEditTime: 2022-11-30 10:07:16
 * @Description: file content
 * @FilePath: \identityserver4web\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.prototype.$author = "妄揽明月";
Vue.use(VueRouter);
const farmeOut = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Auth/login.vue"),
  },{
    path: "/isLogin",
    name: "isLogin",
    component: () => import("../views/Auth/isLogin.vue"),
  },
  {
    path: "/callback",
    name: "callback",
    component: () => import("../views/Auth/callback.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/Auth/logout.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("../views/Auth/error.vue"),
  },
  {
    path: "/refresh",
    name: "refresh",
    component: () => import("../views/Auth/refresh.vue"),
  },
  {
    path: "/wxLogin",
    name: "wxLogin",
    component: () => import("../views/Auth/wxLogin.vue"),
  },
];
const farmeIn = [
  {
    path: "/",
    name: "main",
    component: () => import("../views/Main.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes: [...farmeOut, ...farmeIn],
});

export { router, farmeOut };
